import download from "downloadjs";
import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";
import { exportMultipleEvidenceCocPDF } from "./_coc";

export async function createCocRecord(
  values = {
    evidence_id: 0,
    custody_to: "",
    custody_from: "",
    reason: "",
    timestamp: "",
    entered_by: "",
  }
) {
  return await httpPost(`/evidence/${values.evidence_id}/coc`, values);
}

export async function createIntakeDetails(values = {}) {
  return await httpPost(
    `/evidence/${values.evidence_id}/coc/intake-details`,
    values
  );
}

export async function getCocRecords(options = { evidence_id: null }) {
  return await httpGet(`/evidence/${options.evidence_id}/coc`);
}

export async function updateCocRecord(id, values) {
  return await httpPatch(`/evidence/${values.evidence_id}/coc/${id}`, values);
}

export async function deleteCocRecord(id, values) {
  return await httpDelete(`/evidence/${values.evidence_id}/coc/${id}`);
}

export async function getCocMoveReasons() {
  return await httpGet(`/evidence/coc/move-reasons`);
}

export async function moveEvidence(values = {}) {
  return await httpPatch(
    `/evidence/${values.evidenceInfo.evidence_id}/coc/move`,
    values
  );
}

export async function createEvidenceCocPDF(values) {
  const response = await httpPost(
    `/evidence/${values.evidence.evidence_id}/coc/coc-report`,
    values
  );

  download(
    `data:application/pdf;base64,${response.data}`,
    response.filename,
    "application/pdf"
  );
}

export async function createEvidenceIntakePDF(values) {
  const response = await httpPost(
    `/evidence/${values.evidence.evidence_id}/coc/intake-form`,
    values
  );

  download(
    `data:application/pdf;base64,${response.data}`,
    response.filename,
    "application/pdf"
  );
}

export async function createEvidenceReleasePDF(values) {
  const response = await httpPost(
    `/evidence/${values.evidence.evidence_id}/coc/release-form`,
    values
  );

  download(
    `data:application/pdf;base64,${response.data}`,
    response.filename,
    "application/pdf"
  );
}

// Bulk Coc
export async function createBulkCocRecords(values = {}) {
  return await httpPost(`/evidence/bulk-coc`, values);
}

export async function migrateItems(values) {
  return await httpPost(`/evidence/bulk-coc/migrate-items`, values);
}

export async function createEvidenceMultiIntakePDF(values) {
  const response = await httpPost(
    `/evidence/bulk-coc/multi-intake-form`,
    values
  );

  download(
    `data:application/pdf;base64,${response.data}`,
    response.filename,
    "application/pdf"
  );
}

export async function createEvidenceMultiReleasePDF(values) {
  const response = await httpPost(
    `/evidence/bulk-coc/multi-release-form`,
    values
  );

  download(
    `data:application/pdf;base64,${response.data}`,
    response.filename,
    "application/pdf"
  );
}

const EvidenceCocAPI = {
  createCocRecord,
  createIntakeDetails,
  createBulkCocRecords,
  getCocRecords,
  updateCocRecord,
  deleteCocRecord,
  getCocMoveReasons,
  moveEvidence,
  createEvidenceCocPDF,
  createEvidenceIntakePDF,
  createEvidenceReleasePDF,
  migrateItems,
  createEvidenceMultiIntakePDF,
  createEvidenceMultiReleasePDF,
  exportMultipleEvidenceCocPDF,
};

export default EvidenceCocAPI;
